// Auth connects to the SherloQ Admin identityPoolId & userPoolId on dev
// API connects to the SherloQ Admin API on dev
export const aws_exports: object = {
    Auth: {
        identityPoolId: 'us-east-1:753464e5-c30e-42a8-a74f-25688bbd7d87',
        region: 'us-east-1',
        userPoolId: 'us-east-1_wTYt31SAH',
        userPoolWebClientId: '3ribjj9lr8e9f3e587os2ao4ht'
    },
    API: {
        endpoints: [
            {
                name: "SherloQAdmin",
                endpoint: "https://ul21gz7n2h.execute-api.us-east-1.amazonaws.com/dev/"
            },
            {
                name: "SherloQ",
                endpoint: "https://rkhkyovzwb.execute-api.us-east-1.amazonaws.com/dev/"
            },
            {
                name: "SherloQLambdaAPI",
                endpoint: "https://lambda.us-east-1.amazonaws.com/2015-03-31/functions/",
                service: "lambda",
                region: "us-east-1"
            }
        ]
    }
};

// Auth connects to the SherloQ Admin identityPoolId & userPoolId on live
// API connects to the SherloQ Admin API on live
/*
export const aws_exports: object = {
    Auth: {
        identityPoolId: 'us-east-1:c5245fe1-f512-4be3-abba-408a1f345767',
        region: 'us-east-1',
        userPoolId: 'us-east-1_Tp75o9fj3',
        userPoolWebClientId: '3kp3dakoe5s7dtl0i8v6ogih9'
    },
    API: {
        endpoints: [
            {
                name: "SherloQAdmin",
                endpoint: "https://d3gtlcpko8.execute-api.us-east-1.amazonaws.com/prod/"
            },
            {
                name: "SherloQLambdaAPI",
                endpoint: "https://lambda.us-east-1.amazonaws.com/2015-03-31/functions/",
                service: "lambda",
                region: "us-east-1"
            }
        ]
    }
};
*/



// WEBPACK FOOTER //
// ./src/providers/aws/aws-exports.ts